import { IDeleteProjetoUseCase } from "../../../presentation/useCases/delete/delete_projeto_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * DeleteProjetoUseCase
 */

export class DeleteProjetoUseCase implements IDeleteProjetoUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async deleteProjeto(
    IdProjeto: number,
  ): Promise<void> {
    await this.repository.deleteProjeto(IdProjeto);
  }
}
